import React from "react";
import {
  Box,
  Paper,
  Typography,
  Container,
  Link,
  useTheme,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import ForgotPasswordForm from "../forms/ForgotPasswordForm";

const ForgotPasswordPage: React.FC = () => {
  const theme = useTheme();

  return (
    <Container
      maxWidth="sm"
      sx={{ py: 10, display: "flex", justifyContent: "center" }}
    >
      <Paper
        elevation={24}
        sx={{
          p: 5,
          borderRadius: theme.appRadius?.xl || 4,
          width: "100%",
          textAlign: "center",
          bgcolor: "background.paper",
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
          Recover Password
        </Typography>
        <ForgotPasswordForm />
        <Box sx={{ mt: 3 }}>
          <Link
            component={RouterLink}
            to="/auth"
            variant="body2"
            color="secondary"
            underline="hover"
          >
            Back to Login
          </Link>
        </Box>
      </Paper>
    </Container>
  );
};

export default ForgotPasswordPage;
